function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _dec3, _class2, _class3, _descriptor, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

import { Component, register, bind, reactive } from 'ovee.js';
import gsap from 'gsap';

var _class = (_dec = register('audio-toggle'), _dec2 = reactive(), _dec3 = bind('click'), _dec(_class2 = (_class3 = (_temp = /*#__PURE__*/function (_Component) {
  _inherits(_class3, _Component);

  var _super = _createSuper(_class3);

  function _class3() {
    var _this;

    _classCallCheck(this, _class3);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_assertThisInitialized(_this), "isPlaying", _descriptor, _assertThisInitialized(_this));

    return _this;
  }

  _createClass(_class3, [{
    key: "init",
    value: function init() {
      this.audio = document.querySelector('.audio.background-music');
      this.progressBar = document.querySelector('.progress-bar__strap');
      this.isPlaying = !this.audio.paused;
      this.timer = null;
      this.progress = 0;

      if (!this.audio) {
        // eslint-disable-next-line no-console
        console.warn('Audio element not found!');
      }

      this.bind();
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.isPlaying) {
        this.pause();
      } else {
        this.play();
      }
    }
  }, {
    key: "play",
    value: function play() {
      this.audio.play();
      this.isPlaying = true;
    }
  }, {
    key: "pause",
    value: function pause() {
      this.audio.pause();
      this.isPlaying = false;
    }
  }, {
    key: "calcProgress",
    value: function calcProgress(duration, element) {
      var increment = 10 / duration;
      this.progress = Math.min(increment * element.currentTime / 10, 100);
      gsap.set(this.progressBar, {
        scaleX: this.progress
      });
      this.incrementProgressBar(duration, element);
    }
  }, {
    key: "incrementProgressBar",
    value: function incrementProgressBar(duration, element) {
      var _this2 = this;

      if (this.progress < 1) {
        this.timer = setTimeout(function () {
          _this2.calcProgress(duration, element);
        }, 100);
      }
    }
  }, {
    key: "pauseOnMobile",
    value: function pauseOnMobile() {
      if (this.isPlaying && this.isMobile) {
        this.pause();
      }
    }
  }, {
    key: "handlePlay",
    value: function handlePlay(e) {
      var duration = e.target.duration;
      this.calcProgress(duration, this.audio);
    }
  }, {
    key: "bind",
    value: function bind() {
      var _this3 = this;

      this.$on('playing', this.audio, this.handlePlay);
      this.audio.addEventListener('pause', function () {
        clearTimeout(_this3.timer);
      });
      this.$on('resize-x', window, this.pauseOnMobile);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.$on('playing', this.audio, this.handlePlay);
      this.$off('resize-x', window, this.pauseOnMobile);
    }
  }, {
    key: "isMobile",
    get: function get() {
      return window.matchMedia('(max-width: 1023px)').matches;
    }
  }]);

  return _class3;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class3.prototype, "isPlaying", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class3.prototype, "onClick", [_dec3], Object.getOwnPropertyDescriptor(_class3.prototype, "onClick"), _class3.prototype)), _class3)) || _class2);

export { _class as default };